var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedirectDoorInTablet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 240,
    viewBox: "0 0 290 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 214.21H290",
    stroke: "#50E3C0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8867 37.2434C76.8867 31.7205 81.3639 27.2434 86.8867 27.2434H203.113C208.636 27.2434 213.113 31.7206 213.113 37.2434V204.328C213.113 209.851 208.636 214.328 203.113 214.328H86.8867C81.3639 214.328 76.8867 209.851 76.8867 204.328V37.2434Z",
    fill: "#C1FBED",
    stroke: "#50E3C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.601 8.22942C116.371 6.88344 110.489 11.6305 110.489 18.0039V114.603V126.39V222.989C110.489 229.362 116.371 234.109 122.601 232.763L205.225 214.911C209.828 213.917 213.113 209.846 213.113 205.137V126.39V114.603V35.8556C213.113 31.1466 209.828 27.0756 205.225 26.0811L122.601 8.22942Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.601 8.22942L122.39 9.20686L122.601 8.22942ZM122.601 232.763L122.39 231.786H122.39L122.601 232.763ZM205.225 214.911L205.014 213.934L205.225 214.911ZM205.225 26.0811L205.014 27.0586L205.225 26.0811ZM111.489 18.0039C111.489 12.2678 116.783 7.99548 122.39 9.20686L122.812 7.25197C115.96 5.7714 109.489 10.9931 109.489 18.0039H111.489ZM111.489 114.603V18.0039H109.489V114.603H111.489ZM109.489 114.603V126.39H111.489V114.603H109.489ZM109.489 126.39V222.989H111.489V126.39H109.489ZM109.489 222.989C109.489 229.999 115.96 235.221 122.812 233.741L122.39 231.786C116.783 232.997 111.489 228.725 111.489 222.989H109.489ZM122.812 233.741L205.436 215.889L205.014 213.934L122.39 231.786L122.812 233.741ZM205.436 215.889C210.499 214.795 214.113 210.317 214.113 205.137H212.113C212.113 209.375 209.156 213.039 205.014 213.934L205.436 215.889ZM214.113 205.137V126.39H212.113V205.137H214.113ZM214.113 126.39V114.603H212.113V126.39H214.113ZM212.113 35.8556V114.603H214.113V35.8556H212.113ZM205.014 27.0586C209.156 27.9536 212.113 31.6175 212.113 35.8556H214.113C214.113 30.6757 210.499 26.1976 205.436 25.1037L205.014 27.0586ZM122.39 9.20686L205.014 27.0586L205.436 25.1037L122.812 7.25197L122.39 9.20686Z",
    fill: "#50E3C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.968 120.786C129.968 124.14 127.85 126.643 125.473 126.643C123.097 126.643 120.979 124.14 120.979 120.786C120.979 117.432 123.097 114.929 125.473 114.929C127.85 114.929 129.968 117.432 129.968 120.786Z",
    fill: "#50E3C0",
    stroke: "#50E3C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.744 119.472C127.744 118.25 128.829 117.314 130.037 117.493L136.935 118.515C137.916 118.661 138.642 119.502 138.642 120.494V121.305C138.642 122.315 137.89 123.166 136.887 123.29L129.989 124.142C128.796 124.289 127.744 123.359 127.744 122.157V119.472Z",
    fill: "#50E3C0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 215.21,
    width: 2,
    height: 75,
    transform: "rotate(-90 0 215.21)",
    fill: "url(#paint0_linear_1509_20216)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 75,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 290 215.21)",
    fill: "url(#paint1_linear_1509_20216)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1509_20216",
    x1: 0.999998,
    y1: 215.21,
    x2: 0.999998,
    y2: 290.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1509_20216",
    x1: 0.999998,
    y1: 0,
    x2: 0.999998,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectDoorInTablet);
export default __webpack_public_path__ + "static/media/RedirectDoorInTablet.d787b8a23fc75f2059fbae94ea0982f4.svg";
export { ForwardRef as ReactComponent };